import { useCubeData } from 'modules/Cube/domain/selectors/useCubeData'

/**
 * Whether an amendment quote is holding the schedule open in the editor, and
 * which quote that is. Everything editable is already switched off through
 * available features - this is for the parts of the view that need to say why.
 */
export const useAmendmentLock = () => {
  const { data } = useCubeData()

  return {
    isLockedByAmendment: Boolean(data.common.lockedByQuoteId),
    lockedByQuoteId: data.common.lockedByQuoteId
  }
}
